import { Modal } from 'antd'
import React, { useState } from 'react'
import { Form, Row, Col, Space, Table,Flex,Button } from 'antd'    
import classes from '../demo.module.css'
function DemoTs1Report() {
    const [open,setOpen] = useState()
    const [form] = Form.useForm()
    const requiredMark = <span style={{ color: 'red' }}>*</span>
    // 格式化金额显示
    const formatCurrency = (text) => (
        <span>
            ￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}
        </span>
    );

    // 团队收入
    const incomeData = [
        {
            ddsr_id: 1,
            ddsr_kh_name: '抖音平台',
            ddsr_amount: 1200,
            ddsr_name: '抖音下单',
        },
    ]
    const incomeColumns = [
       {  
           dataIndex: 'index', 
           width: 42, 
           key: '序号' ,
           render: (text, record, index) => index + 1,
           title: '序号',
       },       
     
       { 
           title: '收款客户', 
           dataIndex: 'ddsr_kh_name', 
           width: 200, 
           key: 'ddsr_kh_name' ,           
       },      
       { 
            title: '收款金额', 
            dataIndex: 'ddsr_amount', 
            width: 200, 
            key: 'ddsr_amount',
            render: (text) => <span style={{ color: 'red' }}>{formatCurrency(text)}</span>
       },
       { 
           title: '收款事由', 
           dataIndex: 'ddsr_name', 
           key: 'ddsr_name',
       },                                  
      
       {
           title: '编号    ',
           dataIndex: 'ddsr_id',
           width: 60,
           key: 'ddsr_id',
           
           
       }
    ];
    // 团队成本
    const costData = [
        {
            ddzc_id: 1,
            ddzc_kh_name: '顺通车队',
            ddzc_amount: 600,
            ddzc_content: '商务车费',
        },
        {
            ddzc_id: 2,
            ddzc_kh_name: '导游王建萍',
            ddzc_amount: 200,
            ddzc_content: '导服',
        },       
        {
            ddzc_id: 3,
            ddzc_kh_name: '导游王建萍',
            ddzc_amount: 120,
            ddzc_content: '餐费',
        },       
    ]
    const costColumns = [
        {  
            dataIndex: 'index', 
            width: 44, 
            key: 'index' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },
        { 
            title: '付款客户', 
            dataIndex: 'ddzc_kh_name', 
            width: 200, 
            key: 'ddzc_kh_name',
            
        },
        { 
             title: '付款金额', 
             dataIndex: 'ddzc_amount',    
             width: 200, 
             key: 'ddzc_amount', 
             render: formatCurrency 
         },
        { 
            title: '备注', 
            dataIndex: 'ddzc_content', 
            key: 'ddzc_content',
        },    
       
        {
            title: '编号',
            width: 60, 
            key:'ddzc_id',
            dataIndex:'ddzc_id',            
        },
       
     ];
    // 团队费用 
    const expenseData = [
        {
            fy_id: 1,
            fy_kh_name: '抖音平台',
            fy_amount: 10,
            fy_content: '平台扣点',
        },
    ]
    const expenseColumns = [
        {  
            dataIndex: 'index', 
            width: 44, 
            key: '序号' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },       
        { 
            title: '费用客户', 
            dataIndex: 'fy_kh_name', 
            width: 200, 
            key: 'fy_kh_name' ,
           
        },      
        { 
             title: '费用金额', 
             dataIndex: 'fy_amount', 
             width: 200, 
             key: 'fy_amount',
             render: (text) => <span style={{ color: '#3366cc' }}>{formatCurrency(text)}</span>
        },
        { 
            title: '备注', 
            dataIndex: 'fy_content', 
            key: 'fy_content',
            
        },                               
       
        {
            title: '编号    ',
            dataIndex: 'fy_id',
            width: 60,
            key: 'fy_id',
            
            
        }
     ];
    //团队借款
    const loanData = [
        {
            jk_id: 1,
            jk_kh_name: '导游王建萍',
            jk_amount: 1000,
            jk_content: '借款',
        },
    ]
     const loanColumns = [
        {  
            dataIndex: 'index', 
            width: 44, 
            key: 'index' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },
        { 
            title: '借款人', 
            dataIndex: 'jk_kh_name', 
            width: 200, 
            key: 'jk_kh_name',            
        },
        { 
             title: '借款金额', 
             dataIndex: 'jk_amount',    
             width: 200, 
             key: 'jk_amount', 
             render: formatCurrency 
         },
        { 
            title: '备注', 
            dataIndex: 'jk_content', 
            key: 'jk_content',
        },    
       
        {
            title: '编号',
            width: 60, 
            key:'jk_id',
            dataIndex:'jk_id',            
        },
       
     ];
    return (
        <>
            <a onClick={() => {setOpen(true)}}>团队报账单</a>
            <Modal open={open} onCancel={() => {setOpen(false)}} width={1230} footer={null}>
            <Form
                form={form}
                layout="horizontal"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3}}
                wrapperCol={{ span: 21 }}   
                variant='filled'
                size='middle'                      
                style={{ maxWidth: 1230 }}
                >    
                    <Row>
                        <Col span={3}></Col>
                        <Col span={18}><div style={{fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'}}>团队报账单</div></Col>
                        <Col span={3}></Col>
                    </Row>
                    <Row style={{width:"1180px"}}>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderTop: '3px solid #000'}}>{requiredMark} 团队名称</Col>
                        <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>武汉市内一日游张先生</Col>  
                        <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>{requiredMark}部门</Col>
                        <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>电商1部</Col>  
                        <Col span={2}  className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>团队收入</Col>
                        <Col span={6}  className={classes.col_right_input} style={{borderTop: '3px solid #000',borderRight:"3px solid #000"}}>共1条，合计1200元
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000',}}>{requiredMark} 起止日期</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{padding:'0 5px',justifyContent:'center'}}>
                            2026-04-29至2026-04-29，共1天
                        </Col>
                        <Col span={2} className={classes.col_bottom_label}>{requiredMark}客户</Col>               
                        <Col span={6} className={classes.col_bottom_input}>张先生</Col>                     
                        <Col span={2}  className={classes.col_middle_label}>团队成本</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                            共3条，合计920元
                        </Col> 
                        {/* 第三行 */}                         
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}>计调</Col>
                        <Col span={6}  className={classes.col_middle_input}>赵艳梅</Col>
                        <Col span={2}  className={classes.col_middle_label}>联系人</Col>
                        <Col span={6}  className={classes.col_middle_input}></Col>
                        <Col span={2}  className={classes.col_middle_label}>收入减成本</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>0元</Col>                        
                        {/* 第四行 */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}>主播</Col>
                        <Col span={6}  className={classes.col_middle_input}>李爱玲</Col>                                    
                        <Col span={2}  className={classes.col_middle_label}>备注</Col>
                        <Col span={6}  className={classes.col_middle_input}>汉口火车站接</Col>
                        <Col span={2}  className={classes.col_middle_label}>团队费用</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>     
                            共1条，合计10元
                        </Col> 
                        {/* 第五行 */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}>网店</Col>
                        <Col span={6}  className={classes.col_middle_input}>抖音</Col>                                    
                        <Col span={2}  className={classes.col_middle_label}>产品</Col>
                        <Col span={6}  className={classes.col_middle_input}>周边游</Col>
                        <Col span={2}  className={classes.col_middle_label}>团队利润</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>     
                            270元，利润率22.5%
                        </Col> 
                        {/* 第六行 */}
                        <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000',borderBottom: '3px solid #000'}}>附件</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 5px',borderBottom: '3px solid #000'}}>
                          无附件
                        </Col>   
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom: '3px solid #000'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom: '3px solid #000'}}>234</Col>                                                        
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom: '3px solid #000'}}>借款</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000",borderBottom: '3px solid #000'}}>
                        共1条，合计1000元
                        </Col>    
                    </Row>
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <Form.Item name="dsbzd_state" noStyle>
                                <Space size={20} >
                                    带{requiredMark}星号的为必填，其他选填
                                    
                                </Space>
                           </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div style={{marginTop:'10px'}}>
                    <Flex align='center' justify='space-between'>
                        <div style={{fontSize:'16px',fontWeight:'bold',color:'red'}}>团队收入</div>     
                        <Button style={{borderColor:'#ff4d4f',color:'#ff4d4f'}} size='small'>新增收入</Button>                  
                    </Flex>
                    <Table 
                        className={classes.pinkHeader}
                        dataSource={incomeData}
                        columns={incomeColumns}
                        pagination={false}
                        style={{marginTop:'10px'}}
                        size='small'
                        rowKey="ddsr_id"                    
                        summary={pageData => {
                            const total = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);    
                            if(total>0){
                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={1} key="summary-2" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={2} key="summary-3" colSpan={1}>
                                        <span style={{color:'red'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} key="summary-4" colSpan={incomeColumns.length - 2} ></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }
                            return null;
                        }}
                        locale={{
                            emptyText: '暂无收款单' // This will display text when the table is empty
                        }}
                    />
                </div>
                <div>
                    <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                        <div style={{fontSize:'16px',fontWeight:'bold',color:'green'}}>团队成本</div>
                        <Button style={{borderColor:'#2e7d32',color:'#2e7d32'}} size='small'>新增成本</Button>                                                    
                    </Flex>
                    <Table 
                        className={classes.greenHeader}
                        dataSource={costData}
                        columns={costColumns}
                        pagination={false}
                        style={{marginTop:'10px'}}
                        size='small'
                        rowKey="ddzc_id"                    
                        summary={pageData => {
                            const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);    
                            if(total>0){
                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={1} key="summary-1" colSpan={1}></Table.Summary.Cell> 
                                        <Table.Summary.Cell index={2} key="summary-2" colSpan={1}>
                                            <span style={{color:'green'}}>合计￥{Number(total).toLocaleString('zh-CN', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} key="summary-3" colSpan={costColumns.length - 2} ></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }
                            return null;
                        }}
                        locale={{
                            emptyText: '暂无付款单' // This will display text when the table is empty
                        }}
                    />
                </div>
                <div>
                    <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                        <div style={{fontSize:'16px',fontWeight:'bold',color:'#3366cc'}}>团队费用</div> 
                        <Button style={{borderColor:'#1565c0',color:'#1565c0'}} size='small'>新增费用</Button>                                      
                    </Flex>
                    <Table 
                        className={classes.blueHeader}
                        dataSource={expenseData}
                        columns={expenseColumns}
                        pagination={false}
                        style={{marginTop:'10px'}}
                        size='small'
                        rowKey="fy_id"                    
                        summary={pageData => {
                            const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);    
                            if(total>0){
                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={1} key="summary-2" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={2} key="summary-3" colSpan={1}>
                                        <span style={{color:'#3366cc'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} key="summary-4" colSpan={expenseColumns.length - 2} ></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }
                            return null;
                        }}
                        locale={{
                            emptyText: '暂无费用单' // This will display text when the table is empty
                        }}
                    />
                </div>
                <div>
                    <Flex align='center' justify='space-between' style={{marginTop:'10px'}}>
                        <div style={{fontSize:'16px',fontWeight:'bold',color:'#660099'}}>团队借款</div> 
                        <Button style={{borderColor:'#660099',color:'#660099'}} size='small'>新增借款</Button>                                      
                    </Flex>
                    <Table 
                        className={classes.purpleHeader}
                        dataSource={loanData}
                        columns={loanColumns}
                        pagination={false}
                        style={{marginTop:'10px'}}
                        size='small'
                        rowKey="jk_id"                    
                        summary={pageData => {
                            const total = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);    
                            if(total>0){
                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={1} key="summary-2" colSpan={1}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={2} key="summary-3" colSpan={1}>
                                        <span style={{color:'#660099'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} key="summary-4" colSpan={loanColumns.length - 2} ></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }
                            return null;
                        }}
                        locale={{
                            emptyText: '暂无借款单' // This will display text when the table is empty
                        }}
                    />
                </div>
                </Modal>
        </>
    )
}

export default DemoTs1Report